// import React from "react";
import Settings from "../services/settings.service";
import Storage from "../services/storage.service";
// import axios from "axios";
// import "url-search-params-polyfill";
// const HTTPforTracker = axios.create();
import * as variables from '../variables'

var Helpers = {};

Helpers.log = function () {
  if (Settings.debug) {
    for (var i = 0; i < arguments.length; i++) {
      console.log(arguments[i]);
    }
  }
};

Helpers.emptyReject = () => {
  return new Promise((resolve, reject) => {
    reject(false);
  });
}

Helpers.emptyPromise = () => {
  return new Promise((resolve, reject) => {
    resolve(true);
  });
}

Helpers.isAppleSafari = () => {
  let user_agent_str = navigator.userAgent.toLowerCase();
  if (
    user_agent_str.indexOf("mac") !== -1 &&
    user_agent_str.indexOf("safari/") !== -1 &&
    user_agent_str.indexOf("chrome/") === -1
  ) {
    return true;
  } else {
    return false;
  }
};

Helpers.windowWidth = () => {
  return window.innerWidth;
};
Helpers.windowHeight = () => {
  return window.innerHeight;
};

Helpers.debug_payment = function () {
  if (Settings.debug_payment) {
    for (var i = 0; i < arguments.length; i++) {
      console.warn(arguments[i]);
    }
  }
};

Helpers.setCookie = (name, value, exdays) => {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = name + "=" + value + ";" + expires + ";path=/";
};

Helpers.jsonParsable = (val) => {
  return (val === 'false' ||
    val === 'true' ||
    (val.length && val[0] === '{' && val[val.length] === '{')
    ||
    (val.length && val[0] === '[' && val[val.length] === ']')
  );
}

Helpers.getCookie = name => {
  if (document.cookie.indexOf(name + "=") === -1) {
    return "";
  } else {
    var pieces = document.cookie.split(";");
    for (var i = 0; i < pieces.length; i++) {
      var piece = pieces[i];
      if (piece.indexOf(name + "=") !== -1) {
        let result = piece.split("=");
        return result[1];
      }
    }
  }
};

Helpers.windowHeight = () => {
  return window.innerHeight;
};
Helpers.isMobile = () => {
  var w = Math.max(
    document.documentElement.clientWidth,
    window.innerWidth || 0
  );
  return w <= 999;
};

Helpers.isMobile600 = () => {
  var w = Math.max(
    document.documentElement.clientWidth,
    window.innerWidth || 0
  );
  return w <= 600;
};

Helpers.luhn = function (number) {
  // var number = 4532814148937827;

  // 1. Convert to string and remove spaces
  number = number.toString().replace(/ /g, "");

  // 2. Split with empty string so it splits character by character
  var pieces = number.split("");

  // pieces = ["4", "5", "3", "2", "8", "1", "4", "1", "4", "8", "9", "3", "7", "8", "2", "7"]
  // In the above array, every item is a string. So we will convert them to number when we want to process on them

  // pop() removes last item and returns it
  var checksum = Number(pieces.pop());

  // Reverse the array for looping convenience
  pieces.reverse();

  var total = 0;

  for (var i = 0; i < pieces.length; i++) {
    // Convert the current number to integer
    pieces[i] = Number(pieces[i]);

    // If alternative number
    if (i % 2 === 0) {
      // Double it
      pieces[i] = pieces[i] * 2;
      // If result is greater than 9 then sum it or else just subtract by 9, the result is same
      if (pieces[i] > 9) {
        pieces[i] -= 9;
      }
    }

    // Add to total for sum of all the numbers
    total += pieces[i];
  }

  // if ((total * 9) % 10 == checksum) {
  // 	Helpers.log("Valid number");
  // } else {
  // 	Helpers.log("Invalid number");
  // }

  return (total * 9) % 10 === checksum;
};

Helpers.sortDefault = (a, b) => {
  return a - b;
};

Helpers.sortByProperty = (property, a, b) => {
  return a[property] - b[property];
};

Helpers.sortByPrice = (a, b) => {
  return a["Price"] - b["Price"];
};

Helpers.sortByFloatProperty = (property, a, b) => {
  return parseFloat(a[property]) - parseFloat(b[property]);
};

Helpers.arrayToKeyedObject = (arr, key) => {
  let obj = {};
  for (let item of arr) {
    obj[item[key]] = item;
  }
  return obj;
};

Helpers.getPaymentReturnURL = fragment => {
  if (window.location.hash !== "") {
    return window.location.origin + window.location.pathname + "#/" + fragment;
  } else {
    return window.location.origin + window.location.pathname + fragment;
  }
};

Helpers.getURLPieces = () => {
  let url = window.location.href;
  let all = {};

  all["params"] = "";
  if (url.indexOf("?") !== -1) {
    all["params"] = url.split("?")[1];
    if (all["params"].indexOf("#/") !== -1) {
      all["params"] = all["params"].split("#/")[0];
    }
  }

  all["base"] = "";
  if (url.indexOf("#/") !== -1) {
    all["base"] = url.split("#/")[1];
    if (all["base"].indexOf("?") !== -1) {
      all["params"] = all["base"].split("#/")[0];
    }
  }

  return all;
};

Helpers.receiverPagesExist = () => {
  return (
    window.location.href.indexOf("payfort_token") !== -1 ||
    window.location.href.indexOf("confirmation") !== -1 ||
    window.location.href.indexOf("absher-validation") !== -1
  );
};

Helpers.exceptionParamsExist = () => {
  return (
    window.location.href.indexOf("payfort_token") !== -1 ||
    window.location.href.indexOf("unsupported-location") !== -1 ||
    window.location.href.indexOf("delivery-unavailable") !== -1 ||
    window.location.href.indexOf("confirmation") !== -1 ||
    window.location.href.indexOf("absher-validation") !== -1
  );
};

Helpers.getNumberWithCountryCode = number => {
  if (number.startsWith("00")) {
    number = number.substring(5, number.length);
    number = "966" + number;
  }
  else if (number.startsWith("0")) {
    number = number.substring(1, number.length);
    number = "966" + number;
  } else {
    if (!number.startsWith("966")) {
      number = "966" + number;
    }
  }
  return number;
};

Helpers.getNumberWithoutCountryCode = number => {
  if (number.startsWith("966")) {
    number = number.substring(3, number.length);
    number = "0" + number;
  }
  return number;
};

Helpers.isHTTPS = () => {
  return window.location.href.startsWith("https://");
};

Helpers.forceNonWWW = () => {
  window.location.href = window.location.href.replace(
    "https://www.",
    "https://"
  );
};

Helpers.isWWW = () => {
  return window.location.href.startsWith("https://www.");
};

Helpers.bytesToGBs = val => {
  return val / 1073741824;
};

Helpers.generateDeviceID = () => {
  return Math.floor(Math.random() * 10000000000 + 1);
};

Helpers.milisecondstoMinutes = val => {
  return val / 1000 / 60;
};

Helpers.toFixedNum = (num, precision) => {
  return (+(Math.round(+(num + "e" + precision)) + "e" + -precision)).toFixed(
    precision
  );
};

Helpers.formatNumber = number => {
  let final = Helpers.toFixedNum(parseFloat(number, 10), 2);
  if (final % 1 === 0) {
    final = parseInt(final, 10).toString()
  }
  return final;
};

Helpers.paddingPhoneNumber = number => {
  let phoneNumber = number
  if (phoneNumber.indexOf(variables.INTERNATIONAL_INIT_CODE) !== -1) {
    phoneNumber = phoneNumber.replace(variables.INTERNATIONAL_INIT_CODE, 0)
  }
  return `${phoneNumber.substr(0, 3)} ${phoneNumber.substr(3, 3)}  ${phoneNumber.substring(6)}`
};

const numberWithCommas = x => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

Helpers.formatCurrency = number => {
  return numberWithCommas(number);
};

Helpers.arrayToObject = (array, keyField) => {
  return array.reduce((obj, item) => {
    obj[item[keyField]] = item;
    return obj;
  }, {});
};

Helpers.objectToArray = (object, keyField) => {
  let keys = Object.keys(object);
  let arr = [];
  for (let key of keys) {
    arr.push(object[key]);
  }
  return arr;
};

Helpers.arrayToObjectSingleCol = array => {
  return array.reduce((obj, item) => {
    obj[item + ""] = item;
    return obj;
  }, {});
};

Helpers.capitalize = (str, lower) => {
  return (lower ? str.toLowerCase() : str).replace(/(?:^|\s)\S/g, function (a) {
    return a.toUpperCase();
  });
};

Helpers.getStorageParams = (key) => {
  let params = window.localStorage.getItem(key);
  window.localStorage.removeItem(key);
  if (params) {
    return JSON.parse(params);
  }
  return params;
};

Helpers.getUserSelection = () => {
  return Helpers.getStorageParams("user_selection")
}

Helpers.getUserSelectionByKey = (key) => {
  const userSelection = Helpers.getStorageParams("user_selection")
  if (userSelection && typeof (userSelection[key]) !== 'undefined') {
    return userSelection[key]
  }
  return null
}

Helpers.clearUserSelectionFlags = () => {
  window.localStorage.removeItem("user_selection");
}


Helpers.getParams = () => {
  let params = {
    string: "",
    pieces: {}
  };
  if (window) {
    if (window.location.href.indexOf("?") !== -1) {
      let search = window.location.href.substring(
        window.location.href.indexOf("?") + 1
      );

      if (search.indexOf("#") !== -1) {
        search = search.substring(0, search.indexOf("#"));
      }

      params.string = search;
      search = search.split("&");

      for (let v = 0; v < search.length; v++) {
        let pair = search[v].split("=");
        params.pieces[pair[0]] = pair[1];
      }
    }
  }
  return params;
};

// datepart: 'y', 'm', 'w', 'd', 'h', 'n', 's'
Helpers.dateDiff = (datepart, fromdate, todate) => {
  datepart = datepart.toLowerCase();
  let diff = todate - fromdate;
  let divideBy = { w: 604800000, d: 86400000, h: 3600000, n: 60000, s: 1000 };

  return Math.floor(diff / divideBy[datepart]);
};

Helpers.monthsInDay = (days) => {
  if (days <= 45) {
    return 1
  } else {
    let durationCutOff = days - 15
    if (durationCutOff % 30 === 0) {
      return Math.floor(durationCutOff / 30)
    } else {
      return Math.floor(durationCutOff / 30 + 1)
    }
  }
};

Helpers.roundOff = (n, dp) => {
  const h = +('1'.padEnd(dp + 1, '0'));
  return Math.round(n * h) / h
}

Helpers.removeLeadingZeros = (num) =>
{
    // traverse the entire string
    for (var i = 0; i < num.length; i++) {
 
        // check for the first non-zero character
        if (num.charAt(i) !== '0') {
            // return the remaining string
            let res = num.substr(i);
            return res;
        }
    }
 
    // If the entire string is traversed
    // that means it didn't have a single
    // non-zero character, hence return "0"
    return "0";
}

Helpers.getStreaminService = () => {
  let business = Storage.get("business", true);
  let streaming = [];
  if (business) {
    business = JSON.parse(business);
    streaming = business?.stf_content_services_web;
  }
  return streaming;
}

Helpers.formatWithPO = (number) => {
  let business = Storage.get("business", true);
  if (business) {
    business = JSON.parse(business);
    const roundUp = new Intl.NumberFormat(
      "en", 
      { 
        maximumFractionDigits: business.price_max_fraction_digits, 
        minimumFractionDigits: business.price_min_fraction_digits 
      }
      ).format(number)
    return roundUp;
  }
  return number;
}

export default Helpers;
